module.exports = __webpack_public_path__ + "catalog/items/firesafety/Exit/Exit.svg";